import { debounce } from 'lodash';
import * as Yup from 'yup';

import { api_validate_signup_email_path } from '@routes';
import request from '@utils/backend-api/request';

interface ValidateEmailParams {
  email: string;
}

const DEBOUNCE_MS = 500;

const validateEmail = async (params: ValidateEmailParams): Promise<boolean> => {
  const response = await request('get', api_validate_signup_email_path(params));
  return response.success;
};

const debounceValidateEmail = debounce(validateEmail, DEBOUNCE_MS, {
  leading: false,
  trailing: true,
});

export default function validateSubscriptionEmail() {
  return Yup.string()
    .required('Email address is required')
    .email('Please enter a valid email')
    .test('validate', 'This email address already has an account', async function (email) {
      if (!!this.parent.userEmail && !!email) {
        // Skip validation if the initial state of email is not null (user is logged in)
        return true;
      }

      const isValid = await debounceValidateEmail({ email });
      return isValid;
    });
}
